import {
  Box,
  Fade,
  Typography,
} from '@mui/material'
import { ReactComponent as ReactIcon } from "../../assets/svgs/icons/react.svg"
import { ReactComponent as AngularIcon } from "../../assets/svgs/icons/angular.svg"
import { ReactComponent as NextJsIcon } from "../../assets/svgs/icons/nextjs.svg"
import { ReactComponent as TailwindIcon } from "../../assets/svgs/icons/tailwindcss.svg"
import { ReactComponent as StyledComponentsIcon } from "../../assets/svgs/icons/styledcomponents.svg"
import SkillsList from '../SkillsList/SkillsList'

const Techs = () => {
  return (
    <Fade in={true} timeout={1000}>
      <Box
        height={'100%'}
        width={'90%'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
      >
        <Typography gutterBottom variant="h5">
          Frontend
        </Typography>
        <SkillsList data={[
          {
            id: 0,
            name: "React",
            icon: ReactIcon
          },
          {
            id: 1,
            name: "React Native",
            icon: ReactIcon,
          },
          {
            id: 2,
            name: "Angular",
            icon: AngularIcon
          },
          {
            id: 3,
            name: "Next.js",
            icon: NextJsIcon,
          },
          {
            id: 4,
            name: "Tailwind CSS",
            icon: TailwindIcon,
          },
          {
            id: 5,
            name: "Styled Components",
            icon: StyledComponentsIcon,
          }
        ]} />
        <Typography gutterBottom variant="h5">
          Backend
        </Typography>
        <SkillsList data={[]} />
        <Typography gutterBottom variant="h5">
          DevOps
        </Typography>
        <SkillsList data={[]} />
      </Box>
    </Fade>
  )
}

export default Techs
